module.exports = __webpack_public_path__ + "prod/1.42.2/img/select-icons-5.d222a6ec.svg";